import './DgeContainer.scss';
import DGELogo from './Logo_teste_H_FundoClaro.png';
import { useIntl } from '@edx/frontend-platform/i18n';
import messages from './messages';

export default function DGEContainer() {
    const { formatMessage } = useIntl();
    let message = 'Log in or register to explore new ways to learn and teach.';
    try {
        message = formatMessage(messages["initial.display.message"]);
    } catch (error) {
        console.error(error);
    }
    return (
        <div className="dge-authn-container">
            <div className="image-dge" style={{
                backgroundImage: `url(${DGELogo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}></div>
            <div className="dge-text-authn">
                {message}
            </div>
        </div>
    );
}
